import { MethodUsedToValueClosingInventory } from '@taxfyle/txf-api-client'

export const INVENTORY_METHODS_MAP: Record<
  MethodUsedToValueClosingInventory,
  string
> = {
  [MethodUsedToValueClosingInventory.Cost]: 'Cost',
  [MethodUsedToValueClosingInventory.LowerOfCostOrMarket]:
    'Lower of cost or market',
  [MethodUsedToValueClosingInventory.Other]: 'Other',
} as const

export const INVENTORY_METHODS = Object.entries(INVENTORY_METHODS_MAP) as [
  code: MethodUsedToValueClosingInventory,
  label: string,
][]
